module.exports = __webpack_public_path__ + "static/media/biteship-jdl.4d681fb5.png";